const CaretUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.3 40.28">
            <path
                fill="#010101"
                d="M46.56 -0.96H54.56V44.04H46.56z"
                transform="rotate(-45 50.556 21.55)"
            ></path>
            <path
                fill="#010101"
                d="M-4.34 16.14H44.629999999999995V24.14H-4.34z"
                transform="rotate(-45 20.141 20.137)"
            ></path>
        </svg>
    )
}

export default CaretUp
